import { GridWallAccessEnum } from 'api/enums';
import {
    GridWallModel,
    GridwallPluginModel,
    GridWallRefreshModel,
    GridwallRequestModel,
    IGridDataModel,
} from 'api/models';
import axios from 'axios';
import { getApiUrl } from 'config/api-url';
import http from 'config/http';
import { GridCellDataModel } from 'modules/plugins/features/gridwall-detail/hooks/useUpdateGridCellForm';

export const getAllGridwall = async () => {
    const { data } = await http.get(`${getApiUrl()}/grid-wall`);

    return GridWallModel.fromObjectList(data);
};

export const getGridwall = async (gridId: string) => {
    const { data } = await http.get(`${getApiUrl()}/grid-wall/${gridId}`);

    return GridWallModel.fromObject(data);
};

export const createGridwall = async (
    payload: Pick<
        GridWallModel,
        'name' | 'gridSize' | 'refreshInterval' | 'access' | 'options' | 'gridData' | 'footerMessage'
    >
) => {
    const { data } = await http.post(`${getApiUrl()}/grid-wall`, payload);

    return GridWallModel.fromObject(data);
};

export const updateGridwallOuter = async (
    gridId: string,
    payload: Pick<
        GridWallModel,
        'name' | 'gridSize' | 'refreshInterval' | 'access' | 'options' | 'gridData' | 'footerMessage'
    >
) => {
    const { data } = await http.patch(`${getApiUrl()}/grid-wall/${gridId}`, payload);

    return GridWallModel.fromObject(data);
};

export const updateGridwallStatus = async (gridId: string, payload: Pick<GridWallModel, 'status'>) => {
    const { data } = await http.patch(`${getApiUrl()}/grid-wall/${gridId}`, payload);

    return GridWallModel.fromObject(data);
};

export const deleteGridwall = async (gridwallId: string) => {
    await http.delete(`${getApiUrl()}/grid-wall/${gridwallId}`);
};

export const updateGridCell = async (gridId: string, gridCellId: string, payload: GridCellDataModel) => {
    const { data } = await http.patch(`${getApiUrl()}/grid-wall/${gridId}/grid-data/${gridCellId}`, {
        gridData: payload,
    });

    return GridWallModel.fromObject(data);
};

export const updateGridwallSortOrder = async (gridId: string, sortOrder: { [x: string]: number }) => {
    const { data } = await http.put(`${getApiUrl()}/grid-wall/${gridId}/sort`, { sortOrder });

    return GridWallModel.fromObject(data);
};

export const gridwallAccess = async (accessCode: string) => {
    const { data } = await axios.get(`${getApiUrl()}/grid-wall/access/${accessCode}`);
    return data as { _id: string; access: GridWallAccessEnum };
};

export const verifyGridwall = async (token: string, payload?: string) => {
    const { data } = await axios.post(`${getApiUrl()}/grid-wall/token/${token}`, {
        accessCode: payload,
    });
    return GridWallModel.fromObject(data);
};

export const getGridwallStreamToken = async (token: string, gridDataId: string, accessCode?: string) => {
    const payload = accessCode ? { accessCode } : {};
    const { data } = await axios.post(
        `${getApiUrl()}/grid-wall/token/${token}/grid-data/${gridDataId}/stream-tokens`,
        payload
    );
    return data.token as string;
};

export const refreshGridwall = async (token: string, payload?: string) => {
    const { data } = await axios.post(`${getApiUrl()}/grid-wall/token/${token}/refresh`, {
        accessCode: payload,
    });
    return GridWallRefreshModel.fromObject(data);
};

export const getGridwallPluginData = async () => {
    const { data } = await http.get(`${getApiUrl()}/plugins/grid-wall`);

    return GridwallPluginModel.fromObject(data);
};

export const activateGridwall = async () => {
    const { data } = await http.post(`${getApiUrl()}/plugins/grid-wall`, {
        details: {},
    });
    return GridWallModel.fromObject(data);
};

export const deactivateGridwall = async () => {
    await http.delete(`${getApiUrl()}/plugins/grid-wall`);
};

export const requestGridwall = async (payload: FormData) => {
    await http.post(`${getApiUrl()}/grid-wall-requests`, payload);
};
export const getGridwallRequest = async () => {
    const { data } = await http.get(`${getApiUrl()}/grid-wall-requests`);

    return GridwallRequestModel.fromObjectList(data);
};
